import { Modal, Upload } from 'antd';
import { IFileWall } from '../../../entities/general.entities';
import Paragrapgh from '../Paragrapgh';
import { useState } from 'react';
import {
  UploadFile,
  UploadChangeParam,
  RcFile,
} from 'antd/lib/upload/interface';
import { PlusOutlined } from '@ant-design/icons';
import { translate } from '../../../lib/lang.helper';
import { useSelector } from 'react-redux';
import { selectLang } from '../../../store/ui/ui.selector';

const readFileWall = (file: IFileWall) => {
  const ext = file.thumbUrl.split('.').pop()?.toLowerCase();
  if (ext === 'heic' || ext === 'heif') {
    const thumbUrl = `https://images.weserv.nl/?url=${encodeURIComponent(
      file.thumbUrl,
    )}&output=jpg`;
    return { ...file, thumbUrl };
  }
  return file;
};

interface Props {
  fileList?: IFileWall[];
  label: string;
  onChange?: (files: IFileWall[]) => void;
  disabled?: boolean;
}

const FilesWall = ({ fileList, label, onChange, disabled }: Props) => {
  const lang = useSelector(selectLang);

  const [previewFile, setPreviewFile] = useState<IFileWall>();

  const handleChange = (info: UploadChangeParam<UploadFile<IFileWall>>) => {
    const { file } = info;
    if (file.status === 'removed' && onChange) {
      onChange([...new Set(fileList?.filter(image => image.uid !== file.uid))]);
    }
  };
  const handleBeforeUpload = (file: RcFile, imgList: RcFile[]) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = e => {
      const { uid, name, type, size } = file;

      if (e.target?.result && onChange) {
        const newFile = {
          uid,
          name,
          type,
          size,
          thumbUrl: e.target.result,
          media_type: type === 'application/pdf' ? 'pdf' : 'image',
        };

        onChange([...new Set(fileList), newFile as IFileWall]);
      }
    };
    return false;
  };

  return (
    <>
      <Paragrapgh
        className='mb-4 d-block'
        size={2}
        color='black-2'
        align='default'
        fontWeight={400}
      >
        {label}
      </Paragrapgh>
      <Upload
        className='pictures-wall mb-24'
        listType='picture-card'
        fileList={fileList?.map(f => readFileWall(f))}
        accept='application/pdf,image/x-png,image/gif,image/jpeg'
        onPreview={v => setPreviewFile(readFileWall(v as any))}
        onChange={handleChange}
        beforeUpload={handleBeforeUpload}
        disabled={disabled}
      >
        <div>
          <PlusOutlined />
          <div style={{ marginTop: 8 }}>
            {translate(lang, 'Upload Image/PDF')}
          </div>
        </div>
      </Upload>
      {previewFile &&
        (previewFile.media_type === 'pdf' ? (
          <Modal
            visible={true}
            title={previewFile.name}
            footer={null}
            onCancel={() => setPreviewFile(undefined)}
            width='90vw'
            style={{ top: 20 }}
            bodyStyle={{ height: '85vh', padding: 0 }}
          >
            <iframe
              width='100%'
              height='100%'
              src={previewFile.thumbUrl}
              style={{ border: 'none' }}
            />
          </Modal>
        ) : (
          <Modal
            visible={true}
            title={previewFile.name}
            footer={null}
            onCancel={() => setPreviewFile(undefined)}
          >
            <img
              src={previewFile.thumbUrl}
              alt='Assessment'
              style={{ width: '100%' }}
            />
          </Modal>
        ))}
    </>
  );
};

export default FilesWall;
